/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

/**
 * wrapper around the useEffect hook to only run on update, not mount
 */
export function useDidUpdateEffect(effect: React.EffectCallback, dependencies: any[] = []) {
  const didMount = React.useRef(false);

  React.useEffect(() => {
    if (didMount.current) {
      effect();
    } else {
      didMount.current = true;
    }
  }, dependencies.concat([effect])); // eslint-disable-line react-hooks/exhaustive-deps
};
